export default "__VITE_ASSET__46fb0114__"